import * as React from 'react';
import { IFullPaginationOptions } from './pagination';


export interface IPagingProps {
    pageText: string;
    paging: IFullPaginationOptions;
}

export class PageText extends React.Component<IPagingProps, any> {
    render() {

        return <>{this.renderResultText()}</>
    }

    renderResultText = () => {
        return <div className="pagination-text rich-text" dangerouslySetInnerHTML={{ __html: this.props.pageText && this.props.pageText.replace("{{PAGENUMBER}}", this.props.paging.pageNumber.toString()).replace("{{TOTALPAGES}}", this.props.paging.totalPages.toString()) }}></div>;
    }
}